import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';


@Injectable()
export class TechnicianService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }


  public getAll(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http.get<any[]>(environment.apiUrl + 'engineer/getall').subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }
  public getActive(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.http.get<any[]>(environment.apiUrl + 'engineer/getActive').subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }


  public get(id: Number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'engineer/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public save(category: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (category.is_edit) {
        this.http.put<any>(environment.apiUrl + 'engineer/put', category).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated category');
        }, error => {
          ////console.log(error);
          reject();
        });
      } else {
        this.http.post<any>(environment.apiUrl + 'engineer/post', category).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added category');
        }, error => {
          ////console.log(error);
          reject();
        });
      }
    });
  }

}
